// Helper for the lowLimitAlert payload on VCN POST/PUT/PATCH requests.

import type { VirtualCardFlatFormValues } from 'src/components/VirtualCardForm/VirtualCardForm'
import { toCents } from 'src/utils/currency.utils'

export type LowLimitAlertWriteShape = {
  alertEnabled: boolean
  amountThresholdCents: number | null
}

export function buildLowLimitAlert(
  flatFields: VirtualCardFlatFormValues,
): LowLimitAlertWriteShape {
  const enabled = !!flatFields.lowBalanceAlertEnabled
  return {
    alertEnabled: enabled,
    amountThresholdCents:
      enabled && flatFields.lowBalanceThresholdDollars !== undefined
        ? toCents(flatFields.lowBalanceThresholdDollars)
        : null,
  }
}
